import styled from 'styled-components'
import { COLORS as OLD_COLORS } from '@monthio/react-components'
import { COLORS } from '@monthio/design-system'

export const StyledOrderedList = styled.ol<{ $compact?: boolean }>`
	counter-reset: my-ol-counter;
	list-style: none;
	padding: 8px 0;
	margin: 0;
	display: ${(props) => (props.$compact ? 'flex' : 'flex')};
	flex-direction: ${(props) => (props.$compact ? 'column' : 'column')};
	gap: ${(props) => (props.$compact ? '8px' : '0')};
	color: var(--flow-default-color);

	li {
		position: relative;
		padding: ${(props) =>
			props.$compact ? '0 16px 0 32px' : '8px 16px 8px 46px'};
		font-size: 16px;

		${(props) => props.theme.breakpoints.up('sm')} {
			padding-left: ${(props) => (props.$compact ? '32px' : '46px')};
		}
	}

	li:before {
		position: absolute;
		left: 0;
		top: ${(props) => (props.$compact ? '2px' : '10px')};
		width: ${(props) => (props.$compact ? '24px' : '32px')};
		height: ${(props) => (props.$compact ? '24px' : '32px')};
		line-height: ${(props) => (props.$compact ? '24px' : '32px')};
		font-size: ${(props) => (props.$compact ? '12px' : '16px')};
		margin-top: 0;
		color: ${COLORS.primitives.greyscale.white};
		text-align: center;
		background-color: ${OLD_COLORS.PRIMARY};
		content: counter(my-ol-counter, decimal);
		counter-increment: my-ol-counter;
		border-radius: 50%;

		${(props) => props.theme.breakpoints.up('sm')} {
			${(props) =>
				!props.$compact &&
				`
				width: 32px;
				height: 32px;
				line-height: 32px;
				font-size: 16px;
			`}
		}
	}
`

export const StyledListItem = styled.li`
	color: var(--flow-default-color);
`

export const StyledListItemText = styled.div<{ $compact?: boolean }>`
	font-size: 16px;
	font-family: var(--flow-font-family, inherit);
	margin: ${(props) => (props.$compact ? '4px 0' : '0')};
	color: var(--flow-default-color);
	text-align: left;
	line-height: ${(props) => (props.$compact ? 'normal' : '1.467')};

	${(props) => props.theme.breakpoints.up('sm')} {
		font-size: ${(props) => (props.$compact ? '16px' : '18px')};
	}
	${(props) =>
		!props.$compact
			? `
		margin-top: 4px;
		margin-bottom: 4px;
	`
			: ''}
`
